import classNames from 'classnames';
import { IWeatherItem, IResortPathInfo } from 'api/resort/types';
import { NextLinkTr } from 'components/blocks/NextLink';
import { useTemperatureFormatter } from 'i18n/unitFormat';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { Routes } from 'routes';
import { isEmpty } from 'util/isEmpty';
import { IconWeather } from 'components/resort/IconWeather';

import styles from './styles.module.scss';

interface ITodayWeatherProps {
  base?: IWeatherItem['base'],
  type?: IWeatherItem['type'],
  resort: IResortPathInfo,
}

const TodaysWeather = ({
  base,
  type,
  resort,
}: ITodayWeatherProps) => {
  const { t } = useOTSTranslation('common');
  const tempFormat = useTemperatureFormatter();

  return (
    <div className={styles.item}>
      <div className={styles.itemHeader}>
        <span className={classNames('h4', styles.h4)}>{t('resort.skiReport.todayTemp')}</span>
        <NextLinkTr href={Routes.resortWeather(resort)}>{t('resort.skiReport.fullForecast')}</NextLinkTr>
      </div>
      <div className={styles.cols}>
        {(!isEmpty(base?.max) || !isEmpty(base?.min)) && (
          <div>
            <span className={classNames('h4', styles.h4)} title={t('resort.skiReport.toolTipTemperature')}>
              {tempFormat([base?.max, base?.min], ' / ', 'common.dash')}
            </span>
            <span>{t('resort.skiReport.highLow')}</span>
          </div>
        )}
        <div>
          <IconWeather
            title={type}
            className={styles.weatherType}
          />
          <span>
            <NextLinkTr
              href={Routes.resortWeather(resort)}
              className={styles.fhLink}
            >
              {t('resort.skiReport.fullForecast')}
            </NextLinkTr>
          </span>
        </div>
      </div>
    </div>
  );
};

export default TodaysWeather;
